import { DateTime } from 'luxon';
import { logintimeChange } from '@holmescorp/lcc-state';
import { publish } from '@holmescorp/pub-sub';
export const login = (actor, loginTime, logoutTime) => {
    const { portal_userid: userid, sessionid } = window.hcstatic;
    const recordLogin = (now) => {
        logintimeChange({ logintime: now });
    };
    const now = DateTime.now();
    if (loginTime) {
        if (logoutTime) {
            const lastLoginTime = DateTime.fromISO(loginTime);
            const lastLogoutTime = DateTime.fromISO(logoutTime);
            const loginLogoutDiff = lastLogoutTime.diff(lastLoginTime).as('hours');
            const logoutNowDiff = now.diff(lastLogoutTime).as('hours');
            const okToLogin = loginLogoutDiff > 0 && logoutNowDiff > 0;
            if (okToLogin) {
                recordLogin(now.toISO());
            }
        }
    }
    else {
        recordLogin(now.toISO());
    }
    publish('notify:event', {
        event: 'remote:site:login',
        recipient: userid,
        'from-sessionid': sessionid,
        echo: false,
        message: {
            action: 'login',
            userid: userid
        }
    });
};
